/* eslint-disable import/no-anonymous-default-export */
import http from 'core/http-common'

export interface ICampusServiceExists {
  isHealthServiceExist: boolean
  isCoiffeurServiceExist: boolean
  isGymServiceExist: boolean
  isLactationServiceExist: boolean
  isParkAreaServiceExist: boolean
  isMeetingServiceExist: boolean
  isPoolVehicleServiceExist: boolean
  isAnyExist: boolean
}

class CampusService {
  getCampusServiceExists() {
    return http.get<ICampusServiceExists>(`CampusService/GetExists`)
  }
}

export default new CampusService()
